import {
  Button,
  ErrorIcon,
  IconButton,
  ListItem,
  ListItemText,
  OpenInNewIcon,
  Stack,
  Tag,
  Typography,
  ViewIcon,
} from '@all-manager/design-system-v2';
import { type Props, useDocumentIndexingItem } from './useDocumentIndexingItem';


export default function DocumentIndexingItem(props: Props) {
  const hook = useDocumentIndexingItem(props);

  return (
    <ListItem divider={props.divider}>
      <ListItemText
        disableTypography
        primary={(
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={2}
            alignItems={{ xs: 'flex-start', sm: 'center' }}
            justifyContent="space-between"
          >
            {/* Document Info */}
            <Stack spacing={0.5}>
              <Stack direction="row" spacing={1} alignItems="center" wrap="wrap">
                <Typography variant="body1Emphasis">
                  {hook.item.name}
                </Typography>
                <Tag
                  color={hook.statusColor}
                  variantIcon="state"
                  label={hook.statusLabel}
                />
                {hook.item.documentTypeName ? (
                  <Tag color="default" label={hook.item.documentTypeName} />
                ) : null}
                {hook.item.status === 'error' && hook.item.attempts > 0 ? (
                  <Tag
                    color={hook.item.attempts >= 5 ? 'cancelled' : 'pending'}
                    label={`${hook.item.attempts}/5 essais`}
                  />
                ) : null}
              </Stack>

              <Stack direction="row" spacing={1} alignItems="center" wrap="wrap">
                {hook.formattedExtractedAt ? (
                  <Typography variant="caption">
                    Dernière indexation : {hook.formattedExtractedAt} ({hook.relativeExtractedAt})
                  </Typography>
                ) : (
                  <Typography variant="caption">En attente de traitement</Typography>
                )}

                {hook.item.error ? (
                  <span
                    style={{
                      color: '#d32f2f',
                      maxWidth: 360,
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                    }}
                    title={hook.item.error}
                  >
                    <Typography variant="caption">
                      {hook.item.error}
                    </Typography>
                  </span>
                ) : null}
              </Stack>


            </Stack>

            {/* Actions */}
            <Stack
              direction="row"
              spacing={1}
              alignItems="center"
            >
              {hook.canViewContent ? (
                <Button
                  variant="text"
                  size="small"
                  color="default"
                  startIcon={<ViewIcon />}
                  onClick={hook.handleViewContent}
                >
                  Voir le contenu
                </Button>
              ) : null}

              {hook.hasError ? (
                <Button
                  variant="text"
                  size="small"
                  color="default"
                  startIcon={<ErrorIcon />}
                  onClick={hook.handleViewError}
                >
                  Détails de l'erreur
                </Button>
              ) : null}

              {hook.item.fileUrl ? (
                <IconButton
                  size="small"
                  tooltip="Ouvrir le document d'origine"
                  onClick={hook.handleOpenFile}
                >
                  <OpenInNewIcon fontSize="small" />
                </IconButton>
              ) : null}
            </Stack>
          </Stack>
        )}
      />
    </ListItem>
  );
}
